
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, switchMap} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {Identifier} from "../../models/common/Identifier";
import {IncomingInvoicePhaseTaskItem} from "../../models/accounting/IncomingInvoiceItem";
import {ProjectId} from "../../models/projects/Project";
import {IncomingInvoiceModule} from "../../models/accounting/IncomingInvoice";
import {ContractorId} from "../../models/contractor/Contractor";

/** backend api path */
function apiPath( 
    projectId: Identifier<number>,
    contractorId: Identifier< number >
): string {
    return  APP_CONFIG.baseWeb +`invoices/incoming/items/project/${ projectId.rawValue }/contractor/${ contractorId.rawValue }`;
}


/** union of all Bill related action types */
export type IncomingInvoicePhaseTaskItemViewActionTypes = FetchInInvoicePhaseTaskItemActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchInInvoicePhaseTaskItemAction extends ProjectId, ContractorId, ReduxAction< typeof FETCH_IN_INVOICES_PHASE_TASK_ITEM > {
}
export interface FetchInInvoicePhaseTaskItemSuccessAction extends ReduxAction<typeof FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS > {
    payload: IncomingInvoicePhaseTaskItem[]
}
export interface FetchInInvoicePhaseTaskItemErrorAction extends  ErrorAction< typeof FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR >{}

export type FetchInInvoicePhaseTaskItemActionTypes = FetchInInvoicePhaseTaskItemAction
    | FetchInInvoicePhaseTaskItemSuccessAction
    | FetchInInvoicePhaseTaskItemErrorAction
/**
 * redux action constants
 */
export const FETCH_IN_INVOICES_PHASE_TASK_ITEM = "FETCH_IN_INVOICES_PHASE_TASK_ITEM";
export const FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS = "FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS";
export const FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR = "FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR";

/**
 * redux action functions
 */
export function fetchInInvoicePhaseTaskItem(
    projectId: Identifier<number>,
    contractorId: Identifier< number >
) : FetchInInvoicePhaseTaskItemAction {
    return { type: FETCH_IN_INVOICES_PHASE_TASK_ITEM, projectId, contractorId };
}
export function fetchInInvoicePhaseTaskItemSuccess( payload: IncomingInvoicePhaseTaskItem[] ) : FetchInInvoicePhaseTaskItemSuccessAction {
    return { type: FETCH_IN_INVOICES_PHASE_TASK_ITEM_SUCCESS, payload };
}
export function fetchInInvoicePhaseTaskItemError( error: Error ): FetchInInvoicePhaseTaskItemErrorAction {
    return { type: FETCH_IN_INVOICES_PHASE_TASK_ITEM_ERROR, error };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchInInvoicePhaseTaskItemEpic(
    action$: Observable< FetchInInvoicePhaseTaskItemAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_IN_INVOICES_PHASE_TASK_ITEM ),
        switchMap(action => {
            const path = apiPath( action.projectId, action.contractorId );

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => {
                    return fetchInInvoicePhaseTaskItemSuccess(
                        response.response as IncomingInvoicePhaseTaskItem[]
                    )
                }),
                catchError(error => of(
                    fetchInInvoicePhaseTaskItemError( error),
                    eventNotificationError(error, store$, IncomingInvoiceModule.identifier, "fetchInInvoicePhaseTaskItem")
                ))
            );

        })
    );
}